"use strict";const t=e=>{let o=e;return e.shadowRoot&&e.shadowRoot.activeElement&&(o=e.shadowRoot.activeElement),o};export default t;
//# sourceMappingURL=getNormalizedTarget.js.map
